// extracted by mini-css-extract-plugin
export default {"tabPart":"settings_tabPart__4TO1t","tabLink":"settings_tabLink__YTcB1"};